import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromContentful from './contentful.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ContentfulEffects } from './contentful.effects';
import { Insomnia } from '@awesome-cordova-plugins/insomnia/ngx';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromContentful.contentfulFeatureKey,
      fromContentful.reducer,
    ),
    EffectsModule.forFeature([ContentfulEffects]),
  ],
  providers: [Insomnia],
})
export class ContentfulModule {}
